import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';

import type { DialogComponentI } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-wysiwyg-full-screen-dialog',
  imports: [CommonModule],
  template: ``,
})
export class FullScreenDialogComponent implements DialogComponentI<void, void> {
  private readonly elementRef = inject<ElementRef<Element>>(ElementRef);

  public get element() {
    return this.elementRef.nativeElement;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean) {}
}
